import { type Site, type Supply } from '.';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import type Beverage from './beverage';
import type MealCategory from './meal-category';

@JsonApiResource({
  type: 'customer-setting',
})
export default class CustomerSetting extends BaseEntity {
  canOrderSpecialEventMeals: boolean = false;

  @JsonApiRelationship('meal-category') availableMealCategories = new Array<MealCategory>();
  @JsonApiRelationship('beverage') availableBeverages = new Array<Beverage>();
  @JsonApiRelationship('supply') availableSupplies = new Array<Supply>();
  @JsonApiRelationship('site') sitesCanOrderSpecialEventMeals = new Array<Site>();
  @JsonApiProperty({ resolver: Number }) dueDaysToPlaceOrders: number = 2;
  dueTimeToPlaceOrders: string = '12:00';
  @JsonApiProperty({ resolver: Number }) dueDaysToCancelOrders: number = 1;
  dueTimeToCancelOrders: string = '12:00';
  @JsonApiProperty({ resolver: Number }) canOrderSpecialEventMealsAfterDays: number = 2;
  autoAcceptTypicalOrders: boolean = true;
  eligibleForTestMeal: boolean = false;
  prepackMeals: boolean = false;

  constructor(
    id?: CustomerSetting['id'],
    dueDaysToPlaceOrders: CustomerSetting['dueDaysToPlaceOrders'] = 60,
    dueTimeToPlaceOrders: CustomerSetting['dueTimeToPlaceOrders'] = '12:00',
    dueDaysToCancelOrders: CustomerSetting['dueDaysToCancelOrders'] = 35,
    dueTimeToCancelOrders: CustomerSetting['dueTimeToCancelOrders'] = '12:00',
    availableMealCategories = new Array<MealCategory>(),
    availableBeverages = new Array<Beverage>(),
    availableSupplies = new Array<Supply>(),
    canOrderSpecialEventMeals = false,
    canOrderSpecialEventMealsAfterDays = 2,
    sitesCanOrderSpecialEventMeals = new Array<Site>(),
    autoAcceptTypicalOrders: CustomerSetting['autoAcceptTypicalOrders'] = true,
    eligibleForTestMeal: CustomerSetting['eligibleForTestMeal'] = false,
    prepackMeals: CustomerSetting['prepackMeals'] = false
  ) {
    super();
    this.id = id;
    this.dueDaysToPlaceOrders = dueDaysToPlaceOrders;
    this.dueTimeToPlaceOrders = dueTimeToPlaceOrders;
    this.dueDaysToCancelOrders = dueDaysToCancelOrders;
    this.dueTimeToCancelOrders = dueTimeToCancelOrders;
    this.availableMealCategories = availableMealCategories;
    this.availableBeverages = availableBeverages;
    this.availableSupplies = availableSupplies;
    this.canOrderSpecialEventMeals = canOrderSpecialEventMeals;
    this.canOrderSpecialEventMealsAfterDays = canOrderSpecialEventMealsAfterDays;
    this.sitesCanOrderSpecialEventMeals = sitesCanOrderSpecialEventMeals;
    this.autoAcceptTypicalOrders = autoAcceptTypicalOrders;
    this.eligibleForTestMeal = eligibleForTestMeal;
    this.prepackMeals = prepackMeals;
  }
}
